document.addEventListener('alpine:init', () => {
  // Note this should match the CF7 setting
  const RECAPTCHA_SITE_KEY = '6LdzKnAmAAAAAFrVQlTKyZdUtVvLOCtuBggkUN61'
  const GOOGLE_MAPS_API_KEY = 'AIzaSyBaebxTWcqo_rsWOuzaJbvi3mYl8HTbCd8'

  Alpine.data('estimator', () => ({
    busy: false,
    debug: false,
    step: 1,
    totalSteps: 6,
    furthestStep: 1,
    bailStepOffset: 20,
    recaptchaToken: '',
    responseBody: '',
    submitSuccess: '',
    showResponse: false,
    showResults: false,
    fieldData: {},
    init () {
      Iodine.setErrorMessage('required', '[FIELD] field is required')
      // Iodine.rule('validEmail', (value) => {
      //   // Only Mobile Safari 16.4+ supports lookbehind and I don't think
      //   // this super weak email validation is worth it
      //   const re = new RegExp('^.+(?<!((example|test|fake)\.com))$')
      //   return re.test(value)
      // })
      Iodine.setErrorMessage('validEmail', 'Please enter a valid email address')

      // Debug mode?
      this.debug = location.hostname === 'rustysairaz.com.ddev.site' && /debug=true/.test(location.search)
      this.log('Estimator debug mode enabled')

      // Init fieldData
      const fields = [
        'firstName',
        'lastName',
        'email',
        'phone',
        'address',
        'additionalAddress',
        'city',
        'zip',
        'message',
        'preferredContact',

        'systemCategory', // Heat Pump or AC or ?
        'systemSplitOrPackage',
        'systemType', // The official product category, determined "behind the scenes" based on systemCategory and systemSplitOrPackage
        'systemCount',

        'system1IndoorUnitLocation',
        'system1OutdoorUnitLocation',
        'system1CurrentSystem',
        'system1Size',
        'system1Category',
        'system1Product',
        'system1Addons',

        'system2IndoorUnitLocation',
        'system2OutdoorUnitLocation',
        'system2CurrentSystem',
        'system2Size',
        'system2Category',
        'system2Product',
        'system2Addons',

        'currentSystem'
      ]
      fields.forEach(fieldName => {
        this.fieldData[fieldName] = { errorMessage: '',  blurred: false, dirty: false, value: '' }
      })

      this.fieldData.system1Addons.value = this.fieldData.system2Addons.value = Object.keys(__ESTIMATOR_DATA.addonsBySlug)

      // Set default current system
      this.fieldData.currentSystem.value = '1'

      // Add busy class on body when status goes busy
      this.$watch('busy', (value) => {
        if (value === true) {
          document.body.classList.add('busy')
        } else {
          document.body.classList.remove('busy')
        }
      })

      // Remove loading error alert and loading placeholder
      document.getElementById('loadingAlert').remove()
      this.$refs.placeholder.remove()

      // Dispatch an event that we can listen for to pre-populate debug values
      this.$dispatch('estimator-init', this.$root)

      // Track a successful step1 distance
      this.fireAnalyticsEvent(`rm_estimator_step_${this.furthestStep}`)
    },
    stepForward () {
      // Clear any server response
      this.showResponse = false
      if (this.validateActiveSection() && this.step < this.totalSteps) {
        // System category bail
        if (this.step === 1 && ['other'].indexOf(this.fieldData.systemCategory.value) > -1) {
          this.step = this.step + this.bailStepOffset
        // System count bail
        } else if (this.step === 2 && this.fieldData.systemCount.value === 'more') {
          this.step = this.step + this.bailStepOffset
        // System size bail
        } else if (this.step === 3 && (['undersize','oversize'].indexOf(this.fieldData.system1Size.value) > -1 || ['undersize','oversize'].indexOf(this.fieldData.system2Size.value) > -1)) {
          this.step = this.step + this.bailStepOffset
        // Proceed foward
        } else {
          if (this.step === 1) {
            this.setSystemType()
          }
          this.step++
          if (this.step > this.furthestStep) {
            this.furthestStep = this.step
            this.fireAnalyticsEvent(`rm_estimator_step_${this.furthestStep}`)
          }
        }
        // If we're at a bail step, focus bail back button
        if (this.step > this.totalSteps) {
          this.$nextTick(() => {
            this.$refs.bailBack.focus()
          })
        }
      }
    },
    stepBack () {
      this.clearActiveSectionValidation()
      // Clear any server response
      this.showResponse = false
      if (this.step > this.totalSteps) {
        this.step = this.step - this.bailStepOffset
      } else {
        this.step--
      }

      this.focusNextButton()
    },
    setSystemType () {
      let systemCategory = this.fieldData.systemCategory.value || 'ac'
      let splitOrPackage = this.fieldData.systemSplitOrPackage.value || 'split'
      if (systemCategory == 'ac') {
        this.fieldData.systemType.value = 'split-ac-furnace'
      } else if (systemCategory == 'heatpump') {
        this.fieldData.systemType.value = (splitOrPackage == 'split' || splitOrPackage == 'unsure') ? 'split-heat-pump' : 'package-heat-pump'
      }
    },
    focusNextButton () {
      this.$nextTick(() => {
        this.$refs.nextButton.focus()
      })
    },
    validateActiveSection () {
      let allSectionInputsValid = true
      this.getActiveSectionFieldNames().map((name) => {
        this.fieldData[name].blurred = this.fieldData[name].dirty = true
        if (!this.validateField(name)) {
          allSectionInputsValid = false
        }
      })

      return allSectionInputsValid
    },
    getActiveSection () {
      return document.querySelector(`form section[data-step="${this.step}"]`)
    },
    getActiveSectionFieldNames () {
      let nodes = this.getActiveSection() ? [...this.getActiveSection().querySelectorAll('[data-rules]')] : []
      // Remove any nodes with offsetParent equal to null, because this indicates it's hidden
      // https://stackoverflow.com/a/21696585/2073598
      nodes = nodes.filter(node => node.offsetParent !== null)
      // Now just get the unique node names (there could be multiple for radio/checkbox inputs)
      // https://stackoverflow.com/a/14438954/2073598
      return nodes.map(node => node.name).filter((value, index, array) => array.indexOf(value) === index)
    },
    clearActiveSectionValidation () {
      this.getActiveSectionFieldNames().map((name) => {
        this.fieldData[name].errorMessage = ''
      })
    },
    validateSelf (e) {
      this.validateField(e.target.name)
    },
    validateField (fieldName) {
      let el = this.$refs.form.querySelector(`[name=${fieldName}]`)

      // Return if no rules
      if (typeof el.dataset.rules === 'undefined') return true

      let rules = JSON.parse(el.dataset.rules)

      // Return if empty rules
      if (!rules.length) return true

      let messages = typeof el.dataset.messages !== 'undefined' ? JSON.parse(el.dataset.messages) : false
      let validationFieldName = (el.dataset.altName || fieldName).toUpperCase()

      // Set the default field name since "single item checks" don't support field names.
      // This ensures the fieldname is present in the error message
      Iodine.setDefaultFieldName(fieldName)
      let report = Iodine.assert(this.fieldData[fieldName].value, rules)

      if (report.valid === true) {
        this.fieldData[fieldName].errorMessage = ''
      } else {
        this.fieldData[fieldName].errorMessage = messages && messages[report.rule] ? messages[report.rule] : report.error
      }

      return report.valid === true
    },
    onBlur (e) {
      let el = e.target
      this.fieldData[el.name].blurred = true
      this.fieldData[el.name].focused = false
    },
    onFieldInput (e) {
      this.fieldData[e.target.name].dirty = true
    },
    showFieldAsInvalid (fieldName) {
      return this.fieldData[fieldName] !== 'undefined' && this.fieldData[fieldName].errorMessage && this.fieldData[fieldName].blurred && this.fieldData[fieldName].dirty
    },
    select (id, system) {
      if (!id || !system) { return false }
      this.fieldData['system' + system + 'Product'].value = id
      return true
    },
    isSelected(id, system) {
      return id === this.fieldData['system' + system + 'Product'].value
    },
    onEnter (e) {
      if (e.target.tagName !== 'TEXTAREA') {
        e.preventDefault()
      }
    },
    submit (e) {
      if (this.validateActiveSection()) {
        this.busy = true
        // Add Google reCAPTCHA response
        if (typeof grecaptcha !== 'undefined') {
          grecaptcha.ready(function() {
            grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'submit' }).then(function(token) {
              this.recaptchaToken = token
              this._submit(e)
              this.showResponse = true
            }.bind(this))
          }.bind(this))
        }
      }
    },
    /**
     * Handle form submission
     * @param {submit} e HTMLFormElement: submit event
     */
    async _submit(e) {
      this.log('SUBMITITNG', this.recaptchaToken)
      let formData = new FormData(this.$refs.form)
      formData.set('_wpcf7_recaptcha_response', this.recaptchaToken)
      formData.set('systemType', __ESTIMATOR_DATA.systemTypes[this.fieldData.systemType.value])
      formData.set('system1Size', __ESTIMATOR_DATA.sizes[this.fieldData.system1Size.value][1])
      if (this.fieldData.systemCount.value == 2) {
        formData.set('system2Size', __ESTIMATOR_DATA.sizes[this.fieldData.system2Size.value][1])
      }

      let postUrl = window.location.origin + '/wp-json/contact-form-7/v1/contact-forms/2635/feedback'
      this.log('posting to:', postUrl)
      this.logTable(Object.fromEntries(formData))
      this.response = await fetch(postUrl, {
        method: 'POST',
        body: formData,
      })

      this.responseBody = await this.response.json()

      this.busy = false

      if (this.response.ok) {
        this.log('SUCCESS', this.responseBody.message, typeof this.responseBody.invalid_fields !== 'undefined' ? this.responseBody.invalid_fields[0] : null)
        this.submitSuccess = !(typeof this.responseBody.invalid_fields !== 'undefined' && this.responseBody.invalid_fields.length)
        if (this.submitSuccess) {
          this.fireAnalyticsEvent('rm_estimator_completion')
          this.showResults = true
          this.scrollToResponse()
          this.setDefaultCategory()
          this.setRecommendedOption(1)
          this.setRecommendedOption(2)
          this.updateHeroForResults()
        }
      } else {
        this.log('ERROR', this.responseBody.message)
      }
    },
    fireAnalyticsEvent (event) {
      this.log('Firing Analytics Event: ', event)
      dataLayer.push({
        event: 'rm_estimator_event',
        rm_estimator_event_label: event,
      })
    },
    updateHeroForResults () {
      this.$refs.h1.textContent = 'Your estimate is ready!'
      this.$refs.intro.remove()
    },
    setDefaultCategory () {
      this.fieldData.system1Category.value = this.fieldData.system2Category.value = this.fieldData.systemType.value
    },
    getSelectedProduct (system) {
      return __ESTIMATOR_DATA.productsById[this.fieldData['system' + system + 'Product'].value]
    },
    formatUSD (value) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value)
    },
    setRecommendedOption (system) {
      // Get current category category
      let selectedCategory = this.fieldData[`system${system}Category`].value
      let selectedSize = this.fieldData[`system${system}Size`].value
      let visibleProducts = Object.values(__ESTIMATOR_DATA.productsById).filter(product => product.category === selectedCategory && product.size === selectedSize)

      // Select elite tier by default, or premium if no elite available (e.g. with package HPs)
      let recommendedProduct = visibleProducts.filter(product => product.tier == 'Elite')[0]
      recommendedProduct = recommendedProduct ? recommendedProduct : visibleProducts.filter(product => product.tier == 'Premium')[0]
      this.select(recommendedProduct && recommendedProduct.id, system)
    },
    getSummary (system, product = null) {
      product = product || this.getSelectedProduct(system)
      if (!product) return
      let financingOption = __ESTIMATOR_DATA.financingOptionsById[product.financingOptionId]
      let addonsCost = 0
      // To determine addon cost, loop through all enabled addons for this system and add up the cost
      this.fieldData['system' + system + 'Addons'].value.forEach(addonSlug => {
        addonsCost += __ESTIMATOR_DATA.addonsBySlug[addonSlug].price
      })

      let apr = financingOption.apr
      let principal = product.price + addonsCost
      let principalProductOnly = product.price
      let inter = apr / 100 / 12
      let payments = financingOption.term
      let x = Math.pow(1 + inter, payments)
      let monthlyPayment = (principal*x*inter)/(x-1)
      let monthlyPaymentProductOnly = (principalProductOnly*x*inter)/(x-1)

      return {
        product: {
          total: this.formatUSD(product.price),
          monthly: this.formatUSD(monthlyPaymentProductOnly),
        },
        total: this.formatUSD(principal),
        monthly: this.formatUSD(monthlyPayment),
        zeroPercent: this.formatUSD(principal / 12),
        monthlyDisclaimer: financingOption.monthlyDisclaimer,
        zeroPercentDisclaimer: financingOption.zeroPercentDisclaimer,
      }
    },
    scrollToResponse () {
      this.scrollAndFocus(document.querySelector('.Estimator'))
    },
    scrollAndFocus (target) {
      if (!target) return
      const defaultScrollMarginTop = 0
      target.setAttribute('tabindex', '-1')
      target.style.scrollMarginTop = getComputedStyle(target).getPropertyValue('scroll-margin-top') || defaultScrollMarginTop
      target.addEventListener('blur', _ => target.removeAttribute('tabindex'), { once: true })
      requestAnimationFrame(_ => {
        target.scrollIntoView({ behavior: 'smooth' })
        target.focus({ preventScroll: true })
      })
    },
    /**
     * Simple wrapper to conditionally log things
     * @param  {...any} args
     */
    log (...args) {
      if (this.debug) {
        console.log(...args)
      }
    },
    logTable (...args) {
      this.debug && console.table(...args)
    },
  }))

  let s = document.createElement('script')
  s.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places&callback=initMap`
  s.async = true
  document.body.appendChild(s)
})

// The maps API works in the global space
let autocomplete
const addressInput = document.getElementById('address')
window.initMap = function () {
  autocomplete = new google.maps.places.Autocomplete(
    addressInput,
    {
      types: ['address'],
      componentRestrictions: { 'country': ['us'] },
      fields: ['address_component'],
    }
  )

  autocomplete.addListener('place_changed', function () {
    var place = autocomplete.getPlace()

    // Seems backward but place.name is UNDEFINED when a valid place was selected
    if (typeof place.name === 'undefined') {
      fillAddress()
    } else {
      // No place selected
    }
  })

  function fillAddress () {
    // Get the place details from the autocomplete object.
    const place = autocomplete.getPlace()
    let address = ''
    let state = ''
    let zip = ''

    // Get each component of the address from the place details,
    // and then fill-in the corresponding field on the form.
    // place.address_components are google.maps.GeocoderAddressComponent objects
    // which are documented at http://goo.gle/3l5i5Mr
    for (const component of place.address_components) {
      const componentType = component.types[0]

      switch (componentType) {
        case 'street_number':
          address = `${component.long_name} ${address}`
          break

        case 'route':
          address += component.short_name;
          break

        case 'postal_code':
          zip = `${component.long_name}${zip}`;
          break

        case 'locality':
          city = component.short_name
          break

        case 'administrative_area_level_1':
          state = component.short_name
          break
      }
    }
    // We can't just set the value of these fields; we need to update the Alpine model
    document.querySelector('[name=address]')._x_model.set(address)
    document.querySelector('[name=city]')._x_model.set(city)
    document.querySelector('[name=zip]')._x_model.set(zip)
  }
}

// In the event of a maps auth failure, re-enable the autocomplete field and unbind
// autocomplete listener
window.gm_authFailure = function () {
  addressInput.disabled = false
  addressInput.placeholder = 'Enter your address'
  addressInput.style.backgroundImage = ''
  addressInput.focus()
  google.maps.event.clearInstanceListeners(addressInput);

  return false
}
